module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 7